import React, { useEffect, useRef, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import { UploadFile } from 'features/ui/ui.slice';
import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Box, Flex, Text } from 'shared/components/display';
import AbortStatus from 'shared/components/molecules/UploadStatusDrawer/AbortStatus';
import UploadStatusIcon from 'shared/components/molecules/UploadStatusDrawer/UploadStatusIcon';

import COLORS from 'shared/styles/colors';
import { FileUploadStatus } from 'shared/typings/file/enums';

import { uploadDrawerItemStyles } from './styles';

interface Props {
  file: UploadFile;
  filesUploading: UploadFile[];
  newFilesLoading: number;
  updateFileUpload: (id: string, fileUploadStatus: FileUploadStatus, errors?: string | undefined) => void;
  dataCy?: string;
}
const UploadDrawerItem: React.FC<Props> = ({ file, filesUploading, newFilesLoading, updateFileUpload, dataCy }) => {
  const [newUploadsIds, setNewUploadsIds] = useState<Array<string | number>>([]);

  useEffect(() => {
    setNewUploadsIds(() => filesUploading.slice(0, newFilesLoading).map((file) => file.id));
  }, [newFilesLoading, filesUploading]);

  const ref = useRef<HTMLLIElement>(null);
  return (
    <Box
      css={uploadDrawerItemStyles}
      className={cs('upload-drawer-item', {
        'upload-drawer-item--animated': newUploadsIds.includes(file.id),
      })}
      data-cy={dataCy}
    >
      {file?.errors?.length === 0 && (
        <li className="upload-drawer-item__row">
          <Flex className="upload-drawer-item__row__file-name-icon">
            <UploadStatusIcon progress={file?.progress} status={file?.status} />
            <Tooltip content={file?.name} placement="top" portalTarget={ref.current} disabled={file?.name.length < 50}>
              <Text className="upload-drawer-item__file-name">{file?.name}</Text>
            </Tooltip>
          </Flex>

          <AbortStatus file={file} updateFileUpload={updateFileUpload} files={filesUploading} />
        </li>
      )}

      {file?.errors?.map((e: string, errorIndex: number) => (
        <li key={`${file.name}-error-${errorIndex}`} className="upload-drawer-item__row">
          <Flex className="upload-drawer-item__row__file-name-icon">
            <FontAwesomeIcon icon={faTimesCircle} color={COLORS.RED500} />
            <Tooltip content={file?.name} placement="top" portalTarget={ref.current} disabled={file?.name.length < 50}>
              <Text className="upload-drawer-item__file-name">{file?.name}</Text>
            </Tooltip>
          </Flex>
          <Text className="upload-drawer-item__error">{ReactHtmlParser(e)}</Text>
        </li>
      ))}
    </Box>
  );
};

export default UploadDrawerItem;
